import { SettingsPanelController } from '@/game/GameComponents/PhaserGame/Scenes/Settings/SettingsPanelController';
import { waitUntil } from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';
import DefaultButton from '@/game/prefabs/GeneralUI/Buttons/DefaultButton';
import HUDButton from '@/game/prefabs/GeneralUI/Buttons/HUDButton';
import LoadingPanel from '@/game/prefabs/GeneralUI/LoadingPanel';
import UIBlocker from '@/game/prefabs/GeneralUI/UIBlocker';
import RadioButton from '@/game/prefabs/RadioButton/RadioButton';
import SettingToggle from '@/game/prefabs/SettingToggle/SettingToggle';

/* START OF COMPILED CODE */

export default class SettingsPanel extends Phaser.Scene {

	constructor() {
		super("SettingsPanel");

		/* START-USER-CTR-CODE */
    /* END-USER-CTR-CODE */
	}

	editorCreate(): void {

		// settingsPanelContainer
		const settingsPanelContainer = this.add.container(0, 0);

		// uIBlocker
		const uIBlocker = new UIBlocker(this, 0, 0);
		settingsPanelContainer.add(uIBlocker);

		// desktopView
		const desktopView = this.add.container(0, 0);
		settingsPanelContainer.add(desktopView);

		// mainContainer
		const mainContainer = this.add.container(800, 512);
		desktopView.add(mainContainer);

		// bg
		const bg = this.add.nineslice(-348, -360, "Hud1", undefined, 174, 180, 10, 10, 10, 10);
		bg.scaleX = 4;
		bg.scaleY = 4;
		bg.setOrigin(0, 0);
		mainContainer.add(bg);

		// submitButton
		const submitButton = new DefaultButton(this, 0, 308);
		mainContainer.add(submitButton);

		// settingContainer
		const settingContainer = this.add.container(-256, -296);
		mainContainer.add(settingContainer);

		// radioButtonContainer_1
		const radioButtonContainer_1 = this.add.container(244, 392);
		settingContainer.add(radioButtonContainer_1);

		// long
		const long = new RadioButton(this, 0, 144);
		long.name = "long";
		radioButtonContainer_1.add(long);

		// medium
		const medium = new RadioButton(this, 0, 72);
		medium.name = "medium";
		radioButtonContainer_1.add(medium);

		// short
		const short = new RadioButton(this, 0, 0);
		short.name = "short";
		radioButtonContainer_1.add(short);

		// radioButtonContainer
		const radioButtonContainer = this.add.container(244, 104);
		settingContainer.add(radioButtonContainer);

		// clickToPlace
		const clickToPlace = new RadioButton(this, 0, 0);
		clickToPlace.name = "clickToPlace";
		radioButtonContainer.add(clickToPlace);

		// dragNDrop
		const dragNDrop = new RadioButton(this, 0, 72);
		dragNDrop.name = "dragNDrop";
		radioButtonContainer.add(dragNDrop);

		// typing
		const typing = new RadioButton(this, 0, 144);
		typing.name = "typing";
		radioButtonContainer.add(typing);

		// delayLabel
		const delayLabel = this.add.bitmapText(244, 332, "Aronui", "Sound Out Delay");
		delayLabel.setOrigin(0, 0.5);
		delayLabel.tintTopLeft = 5387071;
		delayLabel.tintTopRight = 5387071;
		delayLabel.tintBottomLeft = 5387071;
		delayLabel.tintBottomRight = 5387071;
		delayLabel.text = "Sound Out Delay";
		delayLabel.fontSize = -32;
		settingContainer.add(delayLabel);

		// placementMethodLabel
		const placementMethodLabel = this.add.bitmapText(244, 44, "Aronui", "Controls");
		placementMethodLabel.setOrigin(0, 0.5);
		placementMethodLabel.tintTopLeft = 5387071;
		placementMethodLabel.tintTopRight = 5387071;
		placementMethodLabel.tintBottomLeft = 5387071;
		placementMethodLabel.tintBottomRight = 5387071;
		placementMethodLabel.text = "Controls";
		placementMethodLabel.fontSize = -32;
		settingContainer.add(placementMethodLabel);

		// wordSegmentationToggle
		const wordSegmentationToggle = new SettingToggle(this, -28, 392);
		settingContainer.add(wordSegmentationToggle);

		// articulatoryGesturesToggle
		const articulatoryGesturesToggle = new SettingToggle(this, -28, 320);
		settingContainer.add(articulatoryGesturesToggle);

		// phonemeNameOnCardDropToggle
		const phonemeNameOnCardDropToggle = new SettingToggle(this, -28, 248);
		settingContainer.add(phonemeNameOnCardDropToggle);

		// soundEnabled
		const soundEnabled = new SettingToggle(this, -28, 176);
		settingContainer.add(soundEnabled);

		// musicEnabledToggle
		const musicEnabledToggle = new SettingToggle(this, -28, 104);
		settingContainer.add(musicEnabledToggle);

		// generalLabel_m_1
		const generalLabel_m_1 = this.add.bitmapText(-60, 44, "Aronui", "General");
		generalLabel_m_1.setOrigin(0, 0.5);
		generalLabel_m_1.tintTopLeft = 5387071;
		generalLabel_m_1.tintTopRight = 5387071;
		generalLabel_m_1.tintBottomLeft = 5387071;
		generalLabel_m_1.tintBottomRight = 5387071;
		generalLabel_m_1.text = "General";
		generalLabel_m_1.fontSize = -32;
		settingContainer.add(generalLabel_m_1);

		// header
		const header = this.add.container(0, -348);
		mainContainer.add(header);

		// headerBacking
		const headerBacking = this.add.nineslice(0, 0, "Hud2", undefined, 90, 18, 4, 4, 4, 8);
		headerBacking.scaleX = 4;
		headerBacking.scaleY = 4;
		header.add(headerBacking);

		// headerText
		const headerText = this.add.bitmapText(0, 0, "Aronui", "Player Settings");
		headerText.setInteractive(new Phaser.Geom.Rectangle(0, 0, 174, 30), Phaser.Geom.Rectangle.Contains);
		headerText.setOrigin(0.5, 0.5);
		headerText.tintTopLeft = 985612;
		headerText.tintTopRight = 985612;
		headerText.tintBottomLeft = 985612;
		headerText.tintBottomRight = 985612;
		headerText.text = "Player Settings";
		headerText.fontSize = -32;
		header.add(headerText);

		// closeContainer
		const closeContainer = this.add.container(348, -360);
		closeContainer.scaleX = 2;
		closeContainer.scaleY = 2;
		mainContainer.add(closeContainer);

		// closeButton
		const closeButton = new HUDButton(this, -24, 24, "hud-icons", 245);
		closeButton.scaleX = 2;
		closeButton.scaleY = 2;
		closeContainer.add(closeButton);

		// mobileView
		const mobileView = this.add.container(0, 0);
		mobileView.visible = false;
		settingsPanelContainer.add(mobileView);

		// mainContainer_m
		const mainContainer_m = this.add.container(334, 188);
		mobileView.add(mainContainer_m);

		// bg_m
		const bg_m = this.add.nineslice(0, 0, "Hud1", undefined, 174, 156, 10, 10, 10, 10);
		bg_m.scaleX = 2;
		bg_m.scaleY = 2;
		mainContainer_m.add(bg_m);

		// settingsScrollGroup_m
		const settingsScrollGroup_m = this.add.container(-270, -76);
		mainContainer_m.add(settingsScrollGroup_m);

		// scrollGroupBacking_m
		const scrollGroupBacking_m = this.add.nineslice(-32, -16, "1x1sprite", undefined, 572, 248, 10, 10, 10, 10);
		scrollGroupBacking_m.setOrigin(0, 0);
		scrollGroupBacking_m.alpha = 0.000001;
		settingsScrollGroup_m.add(scrollGroupBacking_m);

		// settingContainer_m
		const settingContainer_m = this.add.container(0, 0);
		settingsScrollGroup_m.add(settingContainer_m);

		// radioButtonContainer_1_m
		const radioButtonContainer_1_m = this.add.container(260, 336);
		settingContainer_m.add(radioButtonContainer_1_m);

		// long_m
		const long_m = new RadioButton(this, 0, -180);
		long_m.scaleX = 0.5;
		long_m.scaleY = 0.5;
		radioButtonContainer_1_m.add(long_m);

		// medium_m
		const medium_m = new RadioButton(this, 0, -144);
		medium_m.scaleX = 0.5;
		medium_m.scaleY = 0.5;
		radioButtonContainer_1_m.add(medium_m);

		// short_m
		const short_m = new RadioButton(this, 0, -108);
		short_m.scaleX = 0.5;
		short_m.scaleY = 0.5;
		radioButtonContainer_1_m.add(short_m);

		// radioButtonContainer_m
		const radioButtonContainer_m = this.add.container(260, 60);
		settingContainer_m.add(radioButtonContainer_m);

		// clickToPlace_m
		const clickToPlace_m = new RadioButton(this, 0, -48);
		clickToPlace_m.name = "clickToPlace_m";
		clickToPlace_m.scaleX = 0.5;
		clickToPlace_m.scaleY = 0.5;
		radioButtonContainer_m.add(clickToPlace_m);

		// dragNDrop_m
		const dragNDrop_m = new RadioButton(this, 0, -12);
		dragNDrop_m.name = "dragNDrop_m";
		dragNDrop_m.scaleX = 0.5;
		dragNDrop_m.scaleY = 0.5;
		radioButtonContainer_m.add(dragNDrop_m);

		// typing_m
		const typing_m = new RadioButton(this, 0, 24);
		typing_m.name = "typing_m";
		typing_m.scaleX = 0.5;
		typing_m.scaleY = 0.5;
		radioButtonContainer_m.add(typing_m);

		// delayLabel_m
		const delayLabel_m = this.add.bitmapText(240, 120, "Aronui", "Sound Out Delay");
		delayLabel_m.setOrigin(0, 0.5);
		delayLabel_m.tintTopLeft = 5387071;
		delayLabel_m.tintTopRight = 5387071;
		delayLabel_m.tintBottomLeft = 5387071;
		delayLabel_m.tintBottomRight = 5387071;
		delayLabel_m.text = "Sound Out Delay";
		delayLabel_m.fontSize = -20;
		settingContainer_m.add(delayLabel_m);

		// placementMethodLabel_m
		const placementMethodLabel_m = this.add.bitmapText(240, -24, "Aronui", "Controls");
		placementMethodLabel_m.setOrigin(0, 0.5);
		placementMethodLabel_m.tintTopLeft = 5387071;
		placementMethodLabel_m.tintTopRight = 5387071;
		placementMethodLabel_m.tintBottomLeft = 5387071;
		placementMethodLabel_m.tintBottomRight = 5387071;
		placementMethodLabel_m.text = "Controls";
		placementMethodLabel_m.fontSize = -20;
		settingContainer_m.add(placementMethodLabel_m);

		// wordSegmentationToggle_m
		const wordSegmentationToggle_m = new SettingToggle(this, 136, 156);
		wordSegmentationToggle_m.scaleX = 0.5;
		wordSegmentationToggle_m.scaleY = 0.5;
		settingContainer_m.add(wordSegmentationToggle_m);

		// articulatoryGesturesToggle_m
		const articulatoryGesturesToggle_m = new SettingToggle(this, 136, 120);
		articulatoryGesturesToggle_m.scaleX = 0.5;
		articulatoryGesturesToggle_m.scaleY = 0.5;
		settingContainer_m.add(articulatoryGesturesToggle_m);

		// phonemeNameOnCardDropToggle_m
		const phonemeNameOnCardDropToggle_m = new SettingToggle(this, 136, 84);
		phonemeNameOnCardDropToggle_m.scaleX = 0.5;
		phonemeNameOnCardDropToggle_m.scaleY = 0.5;
		settingContainer_m.add(phonemeNameOnCardDropToggle_m);

		// soundEnabled_m
		const soundEnabled_m = new SettingToggle(this, 136, 48);
		soundEnabled_m.scaleX = 0.5;
		soundEnabled_m.scaleY = 0.5;
		settingContainer_m.add(soundEnabled_m);

		// musicEnabledToggle_m
		const musicEnabledToggle_m = new SettingToggle(this, 136, 12);
		musicEnabledToggle_m.scaleX = 0.5;
		musicEnabledToggle_m.scaleY = 0.5;
		settingContainer_m.add(musicEnabledToggle_m);

		// generalLabel_m
		const generalLabel_m = this.add.bitmapText(120, -24, "Aronui", "General");
		generalLabel_m.setOrigin(0, 0.5);
		generalLabel_m.tintTopLeft = 5387071;
		generalLabel_m.tintTopRight = 5387071;
		generalLabel_m.tintBottomLeft = 5387071;
		generalLabel_m.tintBottomRight = 5387071;
		generalLabel_m.text = "General";
		generalLabel_m.fontSize = -20;
		settingContainer_m.add(generalLabel_m);

		// scrollBarContainer_m
		const scrollBarContainer_m = this.add.container(420, -32);
		settingsScrollGroup_m.add(scrollBarContainer_m);

		// scrollBarBacking_m
		const scrollBarBacking_m = this.add.nineslice(0, 0, "scrollbar-backing", undefined, 8, 124, 4, 4, 4, 4);
		scrollBarBacking_m.scaleX = 2;
		scrollBarBacking_m.scaleY = 2;
		scrollBarBacking_m.setOrigin(0.5, 0);
		scrollBarContainer_m.add(scrollBarBacking_m);

		// scrollBarHandle_m
		const scrollBarHandle_m = this.add.image(0, 0, "scrollbar-handle");
		scrollBarHandle_m.scaleX = 2;
		scrollBarHandle_m.scaleY = 2;
		scrollBarHandle_m.setOrigin(0.5, 0);
		scrollBarContainer_m.add(scrollBarHandle_m);

		// header_m
		const header_m = this.add.container(2, -152);
		mainContainer_m.add(header_m);

		// headerBacking_m
		const headerBacking_m = this.add.nineslice(0, 0, "Hud2", undefined, 110, 20, 4, 4, 4, 8);
		headerBacking_m.scaleX = 2;
		headerBacking_m.scaleY = 2;
		header_m.add(headerBacking_m);

		// headerText_m
		const headerText_m = this.add.bitmapText(0, 0, "Aronui", "Player Settings");
		headerText_m.setInteractive(new Phaser.Geom.Rectangle(0, 0, 174, 30), Phaser.Geom.Rectangle.Contains);
		headerText_m.setOrigin(0.5, 0.5);
		headerText_m.tintTopLeft = 985612;
		headerText_m.tintTopRight = 985612;
		headerText_m.tintBottomLeft = 985612;
		headerText_m.tintBottomRight = 985612;
		headerText_m.text = "Player Settings";
		headerText_m.fontSize = -24;
		header_m.add(headerText_m);

		// closeContainer_m
		const closeContainer_m = this.add.container(174, -156);
		mainContainer_m.add(closeContainer_m);

		// closeButton_m
		const closeButton_m = new HUDButton(this, -24, 24, "hud-icons", 245);
		closeButton_m.scaleX = 2;
		closeButton_m.scaleY = 2;
		closeContainer_m.add(closeButton_m);

		// loadingPanel
		const loadingPanel = new LoadingPanel(this, 0, 0);
		this.add.existing(loadingPanel);
		loadingPanel.visible = false;

		// long (prefab fields)
		long.buttonLabel = "Long";

		// medium (prefab fields)
		medium.buttonLabel = "Medium";

		// short (prefab fields)
		short.buttonLabel = "Short";

		// clickToPlace (prefab fields)
		clickToPlace.buttonLabel = "Click To Place";

		// dragNDrop (prefab fields)
		dragNDrop.buttonLabel = "Drag & Drop";

		// typing (prefab fields)
		typing.buttonLabel = "Typing";

		// closeButton (prefab fields)
		closeButton.useAlternateTextures = false;

		// long_m (prefab fields)
		long_m.buttonLabel = "Long";

		// medium_m (prefab fields)
		medium_m.buttonLabel = "Medium";

		// short_m (prefab fields)
		short_m.buttonLabel = "Short";

		// clickToPlace_m (prefab fields)
		clickToPlace_m.buttonLabel = "Click To Place";

		// dragNDrop_m (prefab fields)
		dragNDrop_m.buttonLabel = "Drag & Drop";

		// typing_m (prefab fields)
		typing_m.buttonLabel = "Typing";

		// closeButton_m (prefab fields)
		closeButton_m.useAlternateTextures = false;

		this.submitButton = submitButton;
		this.long = long;
		this.medium = medium;
		this.short = short;
		this.clickToPlace = clickToPlace;
		this.dragNDrop = dragNDrop;
		this.typing = typing;
		this.wordSegmentationToggle = wordSegmentationToggle;
		this.articulatoryGesturesToggle = articulatoryGesturesToggle;
		this.phonemeNameOnCardDropToggle = phonemeNameOnCardDropToggle;
		this.soundEnabled = soundEnabled;
		this.musicEnabledToggle = musicEnabledToggle;
		this.closeButton = closeButton;
		this.mainContainer = mainContainer;
		this.desktopView = desktopView;
		this.scrollGroupBacking_m = scrollGroupBacking_m;
		this.long_m = long_m;
		this.medium_m = medium_m;
		this.short_m = short_m;
		this.clickToPlace_m = clickToPlace_m;
		this.dragNDrop_m = dragNDrop_m;
		this.typing_m = typing_m;
		this.wordSegmentationToggle_m = wordSegmentationToggle_m;
		this.articulatoryGesturesToggle_m = articulatoryGesturesToggle_m;
		this.phonemeNameOnCardDropToggle_m = phonemeNameOnCardDropToggle_m;
		this.soundEnabled_m = soundEnabled_m;
		this.musicEnabledToggle_m = musicEnabledToggle_m;
		this.settingContainer_m = settingContainer_m;
		this.scrollBarBacking_m = scrollBarBacking_m;
		this.scrollBarHandle_m = scrollBarHandle_m;
		this.settingsScrollGroup_m = settingsScrollGroup_m;
		this.closeButton_m = closeButton_m;
		this.mainContainer_m = mainContainer_m;
		this.mobileView = mobileView;
		this.loadingPanel = loadingPanel;

		this.events.emit("scene-awake");
	}

	public submitButton!: DefaultButton;
	public long!: RadioButton;
	public medium!: RadioButton;
	public short!: RadioButton;
	public clickToPlace!: RadioButton;
	public dragNDrop!: RadioButton;
	public typing!: RadioButton;
	public wordSegmentationToggle!: SettingToggle;
	public articulatoryGesturesToggle!: SettingToggle;
	public phonemeNameOnCardDropToggle!: SettingToggle;
	public soundEnabled!: SettingToggle;
	public musicEnabledToggle!: SettingToggle;
	public closeButton!: HUDButton;
	public mainContainer!: Phaser.GameObjects.Container;
	public desktopView!: Phaser.GameObjects.Container;
	public scrollGroupBacking_m!: Phaser.GameObjects.NineSlice;
	public long_m!: RadioButton;
	public medium_m!: RadioButton;
	public short_m!: RadioButton;
	public clickToPlace_m!: RadioButton;
	public dragNDrop_m!: RadioButton;
	public typing_m!: RadioButton;
	public wordSegmentationToggle_m!: SettingToggle;
	public articulatoryGesturesToggle_m!: SettingToggle;
	public phonemeNameOnCardDropToggle_m!: SettingToggle;
	public soundEnabled_m!: SettingToggle;
	public musicEnabledToggle_m!: SettingToggle;
	public settingContainer_m!: Phaser.GameObjects.Container;
	public scrollBarBacking_m!: Phaser.GameObjects.NineSlice;
	public scrollBarHandle_m!: Phaser.GameObjects.Image;
	public settingsScrollGroup_m!: Phaser.GameObjects.Container;
	public closeButton_m!: HUDButton;
	public mainContainer_m!: Phaser.GameObjects.Container;
	public mobileView!: Phaser.GameObjects.Container;
	public loadingPanel!: LoadingPanel;

	/* START-USER-CODE */

  private _controller?: SettingsPanelController;
  get controller() {
    return this._controller;
  }

  async create() {
    this.editorCreate();
    await waitUntil(this.time, () => !!this.scene);
    new SettingsPanelController(this);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
